// extracted by mini-css-extract-plugin
export var numberInputContainer = "_65-0";
export var startPickingButton = "_65-1";